import MobileA from './layouts/A'
import MobileB from './layouts/B'

export const MobileFactory = {
  A: MobileA,
  B: MobileB,
}
